/**
 * Login form state + sign-in status flags.
 *
 *   import loginStore from "@/modules/Auth/store/loginStore.js";
 *   loginStore.loginEmail = "jane@example.com";
 *   useStore(loginStore, (s) => s.signInLoading);
 */
class LoginStore {
  #listeners = new Set();

  #loginEmail = "";
  #loginPassword = "";
  #signInLoading = false;
  #signInError = null;

  get loginEmail() { return this.#loginEmail; }
  set loginEmail(v) { this.#loginEmail = v; this.#notify(); }

  get loginPassword() { return this.#loginPassword; }
  set loginPassword(v) { this.#loginPassword = v; this.#notify(); }

  get signInLoading() { return this.#signInLoading; }
  set signInLoading(v) { this.#signInLoading = !!v; this.#notify(); }

  get signInError() { return this.#signInError; }
  set signInError(v) { this.#signInError = v; this.#notify(); }

  subscribe(listener) {
    this.#listeners.add(listener);
    return () => this.#listeners.delete(listener);
  }

  #notify() { this.#listeners.forEach((l) => l()); }

  clear() {
    this.#loginEmail = "";
    this.#loginPassword = "";
    this.#signInLoading = false;
    this.#signInError = null;
    this.#notify();
  }
}

const loginStore = new LoginStore();
export default loginStore;
